var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenRecordMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.896,
    height: 20.5,
    viewBox: "0 0 20.896 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .minus{fill:#6d6d70}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-zooOut",
    transform: "translate(-1066.012 -1073.16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "minus",
    id: "\\uD328\\uC2A4_4088",
    "data-name": "\\uD328\\uC2A4 4088",
    d: "M1084.859,1093.16h-7.325a.412.412,0,0,0,0,.824h7.325a.412.412,0,0,0,0-.824Z",
    transform: "translate(-6.532 -11.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "minus",
    id: "\\uD328\\uC2A4_4089",
    "data-name": "\\uD328\\uC2A4 4089",
    d: "M1086.787,1092.957l-5.537-5.537a8.65,8.65,0,1,0-7.467,3q.438.044.872.043a8.636,8.636,0,0,0,6.03-2.445l5.52,5.52a.412.412,0,0,0,.583-.583Zm-12.923-3.355a7.829,7.829,0,0,1,.809-15.617q.394,0,.791.039a7.83,7.83,0,0,1-1.6,15.578Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenRecordMinus);
export default __webpack_public_path__ + "static/media/PenRecordMinus.3ddf76e0.svg";
export { ForwardRef as ReactComponent };